var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", { staticClass: "form-label required" }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("label", { staticClass: "custom-upload-area flex" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "desc flex" }, [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(_vm.Lang.get("messages.upload-drag-or-browse")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "upload-note" }, [
          _vm._v(_vm._s(_vm.Lang.get("messages.upload-note"))),
        ]),
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        attrs: {
          type: "file",
          hidden: "",
          multiple: _vm.multiple,
          accept: _vm.filesTypes,
        },
        on: { change: _vm.handleFileUpload },
      }),
    ]),
    _vm._v(" "),
    _vm.previewFile
      ? _c("div", { staticClass: "file-preview mt-2" }, [
          _vm.previewIsImage
            ? _c("img", {
                staticStyle: { "max-width": "200px" },
                attrs: { src: _vm.previewFile },
              })
            : _c("p", [_vm._v("تم رفع الملف بنجاح")]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.localErrors[_vm.name]
      ? _c("small", {
          staticClass: "form-text text-danger",
          domProps: { textContent: _vm._s(_vm.localErrors[_vm.name][0]) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "upload-icon flex" }, [
      _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }